import React from 'react';

const LoadingSpinner = ({ className }: { className?: string }) => {
  return <div className={`spinner-loading ${className}`}></div>;
};

export default LoadingSpinner;
